import styled from 'styled-components';

export const MemberBannerSection = styled.section`
    .search-header{
      display:none;
    }
    p{
      color: #01606F;
    } 
`;

export const MainTabSection = styled.section`
   background: #F1FEFF 0% 0% no-repeat padding-box;
   padding:50px 0;
   .nav-tabs{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 6px;
    justify-content: space-between;
    margin-bottom: 37px; 

       .nav-item{
          margin: 0 4px 0 0;
        &:last-child{
          .nav-link{
              border-right:none;
            }
          }
          .nav-link{
            color: #01606F;
            font-family: "Jost", sans-serif;
            font-size:20px;
            font-weight: 500;
            line-height: 29px;
            padding: 10px 127px;
            border: none;
           border-radius: 10px;

            @media screen and (max-width:1366px) { 
              padding: 10px 103px;
            }

            @media screen and (max-width:1200px) { 
              padding: 10px 80px;
            }

            @media screen and (max-width:991px) { 
              padding: 10px 43px;
            }

            @media screen and (max-width:767px) { 
              padding: 10px 15px;
              border-right: 0;
            }

            &.active,&:hover{
                background: #01606F 0% 0% no-repeat padding-box;
                color:#fff;
            } 
          }
       }
   }

   @media (max-width: 767px) {
    .responsive-tabs {
      flex-wrap: wrap;
      gap: 11px 0; 
    }
  
    .responsive-tabs .nav-link {
      flex-basis: 50%;
      text-align: center;
    }
  }
`;
 